import React, { Component } from "react";
import { Form, Row, Col, Button, Input, Select } from "antd";
import styles from "./index.less";

const { Item } = Form;
const { Option } = Select;

@Form.create()
class ListSearch extends Component {
  onSubmit = e => {
    e.preventDefault();
    const { form, fetchList } = this.props;
    const { validateFields } = form;
    validateFields((err, fieldsValue) => {
      if (err) {
        return;
      }
      if (fetchList) {
        const params = {
          name: fieldsValue.name,
          typeId: fieldsValue.typeId,
          status: fieldsValue.status,
          page: 1
        };
        fetchList(params);
      }
    });
  };

  onReset = () => {
    const { form, handleReset } = this.props;
    const { resetFields } = form;
    resetFields();

    if (handleReset) {
      handleReset();
    }
  };

  renderTitle = (formItemLayout, getFieldDecorator) => {
    return (
      <Col span={8}>
        <Item {...formItemLayout} label="活动名称">
          {getFieldDecorator("name", {
            initialValue: ""
          })(<Input placeholder="请搜索活动名称" />)}
        </Item>
      </Col>
    );
  };

  renderType = (formItemLayout, getFieldDecorator) => {
    const { typeList } = this.props;
    return (
      <Col span={8}>
        <Item label="活动类型" {...formItemLayout}>
          {getFieldDecorator(`typeId`, {
            initialValue: ""
          })(
            <Select placeholder="请选择">
              <Option value="">全部</Option>
              {typeList &&
                typeList.map(item => (
                  <option value={item.typeId}>{item.typeName}</option>
                ))}
            </Select>
          )}
        </Item>
      </Col>
    );
  };

  renderStatus = (formItemLayout, getFieldDecorator) => {
    const { statusList } = this.props;
    return (
      <Col span={8}>
        <Item label="活动状态" {...formItemLayout}>
          {getFieldDecorator(`status`, {
            initialValue: ""
          })(
            <Select placeholder="请选择">
              <Option value="">全部</Option>
              {statusList &&
                statusList.map(item => (
                  <option value={item.code}>{item.message}</option>
                ))}
            </Select>
          )}
        </Item>
      </Col>
    );
  };

  renderBtn = () => {
    return (
      <Col style={{ textAlign: "right" }}>
        <Button type="primary" htmlType="submit">
          查询
        </Button>
        <Button style={{ marginLeft: 8 }} onClick={this.onReset}>
          重置
        </Button>
      </Col>
    );
  };

  renderSearch = (formItemLayout, getFieldDecorator) => {
    return (
      <>
        <Row>
          {this.renderTitle(formItemLayout, getFieldDecorator)}
          {this.renderType(formItemLayout, getFieldDecorator)}
          {this.renderStatus(formItemLayout, getFieldDecorator)}
        </Row>
        <Row>{this.renderBtn()}</Row>
      </>
    );
  };

  render() {
    const { form } = this.props;
    const { getFieldDecorator } = form;

    const formItemLayout = {
      // colon: true,
      labelCol: { span: 8 },
      wrapperCol: { span: 16 }
    };

    return (
      <Form className={styles.root} onSubmit={this.onSubmit}>
        {this.renderSearch(formItemLayout, getFieldDecorator)}
      </Form>
    );
  }
}

export default ListSearch;
